import React, { useEffect } from 'react'

export default function SsoSignIn_MD() {
  useEffect(() => {
    window.location.replace(import.meta.env.VITE_REACT_APP_PEPSICO_SIGNIN)
  }, [])

  return <></>
}
